import React from 'react';

const GlobalLoader: React.FC<{ visible?: boolean; text?: string }> = ({ visible = false, text = 'Cargando...' }) => {
  if (!visible) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-slate-900 rounded-lg p-6 flex flex-col items-center gap-4 border border-slate-700 max-w-md">
        <div className="w-10 h-10 rounded-full border-4 border-t-sky-400 border-slate-700 animate-spin" />
        <div className="text-white font-medium text-center whitespace-pre-line">{text}</div>
        <div className="text-slate-400 text-sm text-center">
          Este proceso puede tardar unos segundos según el volumen de datos
        </div>
      </div>
    </div>
  );
};

export default GlobalLoader;
